import {properties} from './properties';

export const environment = {
    clientBannerHeader: properties.clientBannerHeader,
    oktaRedirectUri: properties.oktaRedirectUri,
    oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
    oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
    erumsRedirectCookieName: properties.erumsRedirectCookieName,
    tooltips: properties.tooltips,
    bannerConfiguration: properties.bannerConfiguration,
    PromoTypeDescription: properties.PromoTypeDescription,
    lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
    authApi: '/bin/safeway/unified/userinfo?banner={banner}',
    SSO_URL: '/bin/safeway/sso',
    SIGN_IN_URL: '/account/sign-in.html',
    RE_SIGN_IN_URL: '/account/re-sign-in.html',
    LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',
    qa1: {
        currentEnv: 'qa1',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        API_HEADERS_GET_STORES: {
            'Ocp-Apim-Subscription-Key': '8ca6295a55f54368844b5982edc1cc01',
            'x-swy_banner': '{banner}',
            'x-swy-client-id': 'web-portal',
        },
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        rewardsLookupConfig: {
            featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
            offerDetailsURL: '/abs/qapub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
            adobeImageURL: 'https://images.albertsons-media.com/is/image/ABSStage/',
            leftNavigation: '/content/experience-fragments/www/for_u/navigation/{banner}.caas.json',
            b2BLeftNavigation: '/content/experience-fragments/b2b/for_u/navigation/{banner}.caas.json',
            getprofileAddressPath: '/abs/qapub/cnc/ucaservice/api/uca/customers/{customerId}/profile',
            getRewardsScoreCard: '/abs/qapub/xapi/ocrp/rewards/scorecard',
            getRewardsOffers: '/abs/qapub/web/j4u/api/grocery/rewards/offers',
            getPointForServicesOffers: '/abs/qapub/dce/offergallery/offers/filter',
            getRewardsHistory: '/abs/qapub/xapi/ocrp/rewards/rewardsHistory',
            getRewardHistoryV2Path: '/abs/qapub/xapi/ocrp/rewards/v2/rewardsHistory',
            getRewardHistoryV3Path: '/abs/qapub/xapi/ocrp/rewards/v3/rewardsHistory',
            selectedRewardspath: '/abs/qapub/web/j4u/api/grocery/rewards/mylist',
            offerDetailPath: '/abs/qapub/web/j4u/api/offer',
            offerDetailxAPIPath: '/abs/qapub/xapi/offers',
            couponClipPath: '/abs/qapub/web/j4u/api/offers/clip',
            rewardUnclipPath : '/abs/qapub/web/j4u/api/rewards/unclip?storeId={storeId}',
            birthDayModUnitXF: '/content/experience-fragments/www/for_u/foru-birthday-exp-frag/master.content.html',
            fuelStationModUnitXF: '/content/experience-fragments/www/for_u/foru-rewards-exp-frag/master.content.html',
            checkUnclipDetail: '/abs/qapub/xapi/ocrp/rewards/clippedrewards',
            clientLibUnifiedHeaderUrl: '/etc.clientlibs/wcax-core/clientlibs/clientlib-unified-header/{banner}.min.js',
            nonEndemicAddUrl: '/content/experience-fragments/xf/weeklyad/gam-non-endemic-banner/master.content.html',
            loyaltyPromotions : '/bin/safeway/loyalty/promos',
            loyaltyPromotionsV2: '/abs/qaint/ocsp/partnerofferservice/partnerOffers/allocation',
            loyaltyPromotionsCodeLink: '/abs/qaint/ocsp/partnerofferservice/partnerOffers/promoAllocation',
            upcDataAPI: '/abs/qapub/xapi/catalog/products-by-upc',
            foruTravelBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net?{MDPCID}',
            foruTravelManageBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net/trips?{MDPCID}',
            ucaHttpOptionsGetProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': 'b63410670d33422186409d4ad55c9030',
                'Content-Type': 'application/vnd.safeway.v2+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Name': 'web-portal'
            },
            ucaHttpOptionsUpdateProfile: {
                'Accept': 'application/vnd.safeway.v4+json',
                'Content-Type': 'application/vnd.safeway.v4.merge-patch+json',
                'X-Swy_banner': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': 'b63410670d33422186409d4ad55c9030',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Id': 'web-portal',
                'X-Swy-Client-Name': 'web-portal'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                "Content-Type": "application/vnd.safeway.v2+json",
                "ocp-apim-subscription-key": "da77a6845488408ba1db8d8d39237043"
            },
            xAPIOcrpRewardsHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'da77a6845488408ba1db8d8d39237043',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptionsV3: {
                "Content-Type": "application/vnd.safeway.v3+json",
                'Accept': 'application/vnd.safeway.v3+json',
                'X-ABS-Client-ID': 'WEB',
                "ocp-apim-subscription-key": "da77a6845488408ba1db8d8d39237043"
            },
            j4uHttpOptions30Header: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                'X-IBM-Client-Id': '9b1d97cf-4ddc-4e81-95e5-035c204c4ef6',
                'X-IBM-Client-Secret': 'G1oW7jM5jF5nV7lR8rC6dU4wG1qS8uC5iD7rB5eJ0tD4eO0cJ6',
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            j4uHttpOptionsFilterAPIHeader: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                "ocp-apim-subscription-key": "0c599cf08f045ca4a184e65050ca5f0c5fe16cd253ba52b0dc690bb2fc2db3df",
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            offerDetailsXAPIHeader: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'X-SWY-APPLICATION-TYPE': 'web',
                'X-SWY_API_KEY': 'emjou',
                'X-SWY_VERSION': '2.1'
            },
            j4uHttpOptions: {
                "Content-Type": "application/json",
                "X-Ibm-Client-Id": "9b1d97cf-4ddc-4e81-95e5-035c204c4ef6",
                "X-Ibm-Client-Secret": "G1oW7jM5jF5nV7lR8rC6dU4wG1qS8uC5iD7rB5eJ0tD4eO0cJ6",
                "X-Swy_api_key": "emjou",
                "X-Swy_version": "1.0",
                'X-Swy_banner': '{banner}',
            },
            rewardUnclipHttpOptions: {
                'Content-Type': 'application/json',
                'SWY_BANNER': 'safeway',
                "X-SWY_API_KEY": 'emjou',
                "X-SWY_VERSION": '1.0'
            },
            partnerPromotionV2HttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '4407e126d1de4524880a1b0505093464',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            dynamicPartnerPromoCodeLinkHttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '4407e126d1de4524880a1b0505093464',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            personalizedOffer: {
                apiUrl: '/abs/qaint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
                httpHeaders: {
                    'ocp-apim-subscription-key': '726dd7ab73ce4efbbbdbf36d9119f332',
                    'Content-Type': 'application/vnd.safeway.v1+json',
                },
            },

        },
        freshpassLookupConfig: {
            freshpassURL: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            freshpassTierStatus: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/status',
            freshpassHeaders: {
                'Accept': 'application/vnd.safeway.v2+json',
                'Content-Type': 'application/json',
                'X-SWY_BANNER': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': 'dd394e5d0f9149e2bd9898dcfc0c5d6d',
                'x-swy-client-id': 'web-portal'
            },
            tierStatusHeaders: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Content-Type': 'application/json',
                'x-swy-banner': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': 'dd394e5d0f9149e2bd9898dcfc0c5d6d',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal'
            }
        },
        googleAdConfig: {
            displayAds: {
                bottomAd: true
            },
            adBanners: ['acmemarkets', 'albertsons', 'carrsqc', 'jewelosco', 'pavilions', 'randalls', 'safeway', 'shaws', 'starmarket', 'tomthumb', 'vons'],
            gptScriptSrc: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
            rewardsAdBottom: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes: [
                    [728, 90],
                    [300, 250]
                ],
                sizeMapping: [
                    [
                        [1024, 250],
                        [728, 90],
                    ],
                    [
                        [768, 250],
                        [728, 90],
                    ],
                    [
                        [360, 240],
                        [300, 250],
                    ],
                    [[0, 0], []],
                ],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            },
            endemicBottomAd: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes:  ["fluid"],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            }
        },
    },
    qa2: {
        currentEnv: 'qa2',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        rewardsLookupConfig: {
            featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
            offerDetailsURL: '/abs/acceptancepub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
            adobeImageURL: 'https://images.albertsons-media.com/is/image/ABSStage/',
            leftNavigation: '/content/experience-fragments/www/for_u/navigation/{banner}.caas.json',
            b2BLeftNavigation: '/content/experience-fragments/b2b/for_u/navigation/{banner}.caas.json',
            getprofileAddressPath: '/abs/acceptancepub/cnc/ucaservice/api/uca/customers/{customerId}/profile',
            getRewardsScoreCard: '/abs/acceptancepub/xapi/ocrp/rewards/scorecard',
            getRewardsOffers: '/abs/qa1pub/web/j4u/api/grocery/rewards/offers',
            getPointForServicesOffers: '/abs/acceptancepub/dce/offergallery/offers/filter',
            getRewardsHistory: '/abs/acceptancepub/xapi/ocrp/rewards/rewardsHistory',
            getRewardHistoryV2Path: '/abs/acceptancepub/xapi/ocrp/rewards/v2/rewardsHistory',
            getRewardHistoryV3Path: '/abs/acceptancepub/xapi/ocrp/rewards/v3/rewardsHistory',
            selectedRewardspath: '/abs/qa1pub/web/j4u/api/grocery/rewards/mylist',
            offerDetailPath: '/abs/acceptancepub/web/j4u/api/offer',
            offerDetailxAPIPath: '/abs/acceptancepub/xapi/offers',
            couponClipPath: '/abs/qa1pub/web/j4u/api/offers/clip',
            rewardUnclipPath : '/abs/qa1pub/web/j4u/api/rewards/unclip?storeId={storeId}',
            birthDayModUnitXF: '/content/experience-fragments/www/for_u/foru-birthday-exp-frag/master.content.html',
            fuelStationModUnitXF: '/content/experience-fragments/www/for_u/foru-rewards-exp-frag/master.content.html',
            checkUnclipDetail: '/abs/acceptancepub/xapi/ocrp/rewards/clippedrewards',
            clientLibUnifiedHeaderUrl: '/etc.clientlibs/wcax-core/clientlibs/clientlib-unified-header/{banner}.min.js',
            nonEndemicAddUrl: '/content/experience-fragments/xf/weeklyad/gam-non-endemic-banner/master.content.html',
            upcDataAPI: '/abs/acceptancepub/xapi/catalog/products-by-upc',
            loyaltyPromotions : '/bin/safeway/loyalty/promos',
            loyaltyPromotionsV2: '/abs/acceptanceint/ocsp/partnerofferservice/partnerOffers/allocation',
            loyaltyPromotionsCodeLink: '/abs/acceptanceint/ocsp/partnerofferservice/partnerOffers/promoAllocation',
            foruTravelBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net?{MDPCID}',
            foruTravelManageBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net/trips?{MDPCID}',
            ucaHttpOptionsGetProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'X-SWY_BANNER': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': 'e5b1bf4a9c124561ba364ac53c2cbc66',
                'Content-Type': 'application/vnd.safeway.v2+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Name': 'web-portal'
            },
            ucaHttpOptionsUpdateProfile: {
                'Accept': 'application/vnd.safeway.v4+json',
                'Content-Type': 'application/vnd.safeway.v4.merge-patch+json',
                'X-Swy_banner': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': 'e5b1bf4a9c124561ba364ac53c2cbc66',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Id': 'web-portal',
                'X-Swy-Client-Name': 'web-portal'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                "Content-Type": "application/vnd.safeway.v2+json",
                "ocp-apim-subscription-key": "B64bee335e314def9fd3e33435604ad4"
            },
            xAPIOcrpRewardsHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'B64bee335e314def9fd3e33435604ad4',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptionsV3: {
                "Content-Type": "application/vnd.safeway.v3+json",
                'Accept': 'application/vnd.safeway.v3+json',
                'X-ABS-Client-ID': 'WEB',
                "ocp-apim-subscription-key": "B64bee335e314def9fd3e33435604ad4"
            },
            j4uHttpOptions30Header: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                'X-IBM-Client-Id': '652b1bdf-df33-43e2-81e3-278fecf91c5c',
                'X-IBM-Client-Secret': 'kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY',
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            j4uHttpOptionsFilterAPIHeader: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                "ocp-apim-subscription-key": "b36d76738673b00026603926a770e963c4d933bb0bc1c8f92e52e09b06911e88",
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            offerDetailsXAPIHeader: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'X-SWY-APPLICATION-TYPE': 'web',
                'X-SWY_API_KEY': 'emjou',
                'X-SWY_VERSION': '2.1'
            },
            j4uHttpOptions: {
                "Content-Type": "application/json",
                "X-Ibm-Client-Id": "652b1bdf-df33-43e2-81e3-278fecf91c5c",
                "X-Ibm-Client-Secret": "kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY",
                "X-Swy_api_key": "emjou",
                "X-Swy_version": "1.0",
                'X-Swy_banner': '{banner}',
            },
            rewardUnclipHttpOptions: {
                'Content-Type': 'application/json',
                'SWY_BANNER': '{banner}',
                "X-SWY_API_KEY": 'emjou',
                "X-SWY_VERSION": '1.0'
            },
            partnerPromotionV2HttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '3ff41beb63834cb89cf8662e63c8e0db',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            dynamicPartnerPromoCodeLinkHttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '3ff41beb63834cb89cf8662e63c8e0db',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            personalizedOffer: {
                apiUrl: '/abs/acceptanceint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
                httpHeaders: {
                    'ocp-apim-subscription-key': 'b021c62ef0914b71961f8ec60e55d180',
                    'Content-Type': 'application/vnd.safeway.v1+json',
                },
            },
        },
        freshpassLookupConfig: {
            freshpassURL: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            freshpassTierStatus: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/status',
            freshpassHeaders: {
                'Accept': 'application/vnd.safeway.v2+json',
                'Content-Type': 'application/json',
                'X-SWY_BANNER': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': '002a0b250eae4523b5b8ef483e79f209',
                'x-swy-client-id': 'web-portal'
            },
            tierStatusHeaders: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Content-Type': 'application/json',
                'x-swy-banner': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'ocp-apim-subscription-key': '002a0b250eae4523b5b8ef483e79f209',

            }
        },
        googleAdConfig: {
            displayAds: {
                bottomAd: true
            },
            adBanners: ['acmemarkets', 'albertsons', 'carrsqc', 'jewelosco', 'pavilions', 'randalls', 'safeway', 'shaws', 'starmarket', 'tomthumb', 'vons'],
            gptScriptSrc: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
            rewardsAdBottom: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes: [
                    [728, 90],
                    [300, 250]
                ],
                sizeMapping: [
                    [
                        [1024, 250],
                        [728, 90],
                    ],
                    [
                        [768, 250],
                        [728, 90],
                    ],
                    [
                        [360, 240],
                        [300, 250],
                    ],
                    [[0, 0], []],
                ],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            },
            endemicBottomAd: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes:  ["fluid"],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            }
        },
    },
    qa3: {
        currentEnv: 'qa3',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        rewardsLookupConfig: {
            featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
            offerDetailsURL: '/abs/perfpub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
            adobeImageURL: 'https://images.albertsons-media.com/is/image/ABSStage/',
            leftNavigation: '/content/experience-fragments/www/for_u/navigation/{banner}.caas.json',
            b2BLeftNavigation: '/content/experience-fragments/b2b/for_u/navigation/{banner}.caas.json',
            getprofileAddressPath: '/abs/perfpub/cnc/ucaservice/api/uca/customers/{customerId}/profile',
            getRewardsScoreCard: '/abs/perfpub/xapi/ocrp/rewards/scorecard',
            getRewardsOffers: '/abs/qa1pub/web/j4u/api/grocery/rewards/offers',
            getPointForServicesOffers: '/abs/perfpub/dce/offergallery/offers/filter',
            getRewardsHistory: '/abs/perfpub/xapi/ocrp/rewards/rewardsHistory',
            getRewardHistoryV2Path: '/abs/perfpub/xapi/ocrp/rewards/v2/rewardsHistory',
            getRewardHistoryV3Path: '/abs/perfpub/xapi/ocrp/rewards/v3/rewardsHistory',
            selectedRewardspath: '/abs/qa1pub/web/j4u/api/grocery/rewards/mylist',
            offerDetailPath: '/abs/perfpub/web/j4u/api/offer',
            offerDetailxAPIPath: '/abs/perfpub/xapi/offers',
            couponClipPath: '/abs/qa1pub/web/j4u/api/offers/clip',
            rewardUnclipPath : '/abs/perfpub/web/j4u/api/rewards/unclip?storeId={storeId}',
            birthDayModUnitXF: '/content/experience-fragments/www/for_u/foru-birthday-exp-frag/master.content.html',
            fuelStationModUnitXF: '/content/experience-fragments/www/for_u/foru-rewards-exp-frag/master.content.html',
            checkUnclipDetail: '/abs/perfpub/xapi/ocrp/rewards/clippedrewards',
            clientLibUnifiedHeaderUrl: '/etc.clientlibs/wcax-core/clientlibs/clientlib-unified-header/{banner}.min.js',
            nonEndemicAddUrl: '/content/experience-fragments/xf/weeklyad/gam-non-endemic-banner/master.content.html',
            upcDataAPI: '/abs/perfpub/xapi/catalog/products-by-upc',
            loyaltyPromotions : '/bin/safeway/loyalty/promos',
            loyaltyPromotionsV2: '/abs/perfint/ocsp/partnerofferservice/partnerOffers/allocation',
            loyaltyPromotionsCodeLink: '/abs/perfint/ocsp/partnerofferservice/partnerOffers/promoAllocation',
            foruTravelBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net?{MDPCID}',
            foruTravelManageBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net/trips?{MDPCID}',
            ucaHttpOptionsGetProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'X-SWY_BANNER': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': '2af9cc1fbd3348f1bf4c47ee480542e5',
                'Content-Type': 'application/vnd.safeway.v2+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Name': 'web-portal'
            },
            ucaHttpOptionsUpdateProfile: {
                'Accept': 'application/vnd.safeway.v4+json',
                'Content-Type': 'application/vnd.safeway.v4.merge-patch+json',
                'X-Swy_banner': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': '2af9cc1fbd3348f1bf4c47ee480542e5',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Id': 'web-portal',
                'X-Swy-Client-Name': 'web-portal'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                "Content-Type": "application/vnd.safeway.v2+json",
                "ocp-apim-subscription-key": "83392d1eda6b4306b1166f6f6a832b2a"
            },
            xAPIOcrpRewardsHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '83392d1eda6b4306b1166f6f6a832b2a',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptionsV3: {
                "Content-Type": "application/vnd.safeway.v3+json",
                'Accept': 'application/vnd.safeway.v3+json',
                'X-ABS-Client-ID': 'WEB',
                "ocp-apim-subscription-key": "83392d1eda6b4306b1166f6f6a832b2a"
            },
            j4uHttpOptions30Header: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                'X-IBM-Client-Id': 'f537e42e-b56e-4c08-b4cf-159735dc889b',
                'X-IBM-Client-Secret': 'eL0uY3yM2lF6kJ7jN2fO5jA0qP3lK2vX3pX5hM1cX3nS7uJ3mA',
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            j4uHttpOptionsFilterAPIHeader: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                "ocp-apim-subscription-key": "d4e34bea5de73fff74e98e411208234fc18a2b24f39f04d08239a6c7e16e61b7",
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            offerDetailsXAPIHeader: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'X-SWY-APPLICATION-TYPE': 'web',
                'X-SWY_API_KEY': 'emjou',
                'X-SWY_VERSION': '2.1'
            },
            j4uHttpOptions: {
                "Content-Type": "application/json",
                "X-Ibm-Client-Id": "f537e42e-b56e-4c08-b4cf-159735dc889b",
                "X-Ibm-Client-Secret": "eL0uY3yM2lF6kJ7jN2fO5jA0qP3lK2vX3pX5hM1cX3nS7uJ3mA",
                "X-Swy_api_key": "emjou",
                "X-Swy_version": "1.0",
                'X-Swy_banner': '{banner}',
            },
            rewardUnclipHttpOptions: {
                'Content-Type': 'application/json',
                'SWY_BANNER': '{banner}',
                "X-SWY_API_KEY": 'emjou',
                "X-SWY_VERSION": '1.0'
            },
            partnerPromotionV2HttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '6bbcde1f2e6f4ab08ef05795284d6531',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            dynamicPartnerPromoCodeLinkHttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '6bbcde1f2e6f4ab08ef05795284d6531',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            personalizedOffer: {
                apiUrl: '/abs/perfint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
                httpHeaders: {
                    'ocp-apim-subscription-key': '9f9c5463cdaa444f88c902e8b3f37469',
                    'Content-Type': 'application/vnd.safeway.v1+json',
                },
            },
        },
        freshpassLookupConfig: {
            freshpassURL: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            freshpassTierStatus: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/status',
            freshpassHeaders: {
                'Accept': 'application/vnd.safeway.v2+json',
                'Content-Type': 'application/json',
                'X-SWY_BANNER': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': '2afdf86bd70247b680f7cbc21b82e4ac',
                'x-swy-client-id': 'web-portal'
            },
            tierStatusHeaders: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Content-Type': 'application/json',
                'x-swy-banner': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'ocp-apim-subscription-key': '2afdf86bd70247b680f7cbc21b82e4ac',

            }
        },
        googleAdConfig: {
            displayAds: {
                bottomAd: true
            },
            adBanners: ['acmemarkets', 'albertsons', 'carrsqc', 'jewelosco', 'pavilions', 'randalls', 'safeway', 'shaws', 'starmarket', 'tomthumb', 'vons'],
            gptScriptSrc: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
            rewardsAdBottom: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes: [
                    [728, 90],
                    [300, 250]
                ],
                sizeMapping: [
                    [
                        [1024, 250],
                        [728, 90],
                    ],
                    [
                        [768, 250],
                        [728, 90],
                    ],
                    [
                        [360, 240],
                        [300, 250],
                    ],
                    [[0, 0], []],
                ],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            },
            endemicBottomAd: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes:  ["fluid"],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            }
        },
    },
    stage: {
        currentEnv: 'stage',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        rewardsLookupConfig: {
            featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
            offerDetailsURL: '/abs/stgpub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
            adobeImageURL: 'https://images.albertsons-media.com/is/image/ABSStage/',
            leftNavigation: '/content/experience-fragments/www/for_u/navigation/{banner}.caas.json',
            b2BLeftNavigation: '/content/experience-fragments/b2b/for_u/navigation/{banner}.caas.json',
            getprofileAddressPath: '/abs/stgpub/cnc/ucaservice/api/uca/customers/{customerId}/profile',
            getRewardsScoreCard: '/abs/stgpub/xapi/ocrp/rewards/scorecard',
            getRewardsOffers: '/abs/stgpub/web/j4u/api/grocery/rewards/offers',
            getPointForServicesOffers: '/abs/stgpub/dce/offergallery/offers/filter',
            getRewardsHistory: '/abs/stgpub/xapi/ocrp/rewards/rewardsHistory',
            getRewardHistoryV2Path: '/abs/stgpub/xapi/ocrp/rewards/v2/rewardsHistory',
            getRewardHistoryV3Path: '/abs/stgpub/xapi/ocrp/rewards/v3/rewardsHistory',
            selectedRewardspath: '/abs/stgpub/web/j4u/api/grocery/rewards/mylist',
            offerDetailPath: '/abs/stgpub/web/j4u/api/offer',
            offerDetailxAPIPath: '/abs/stgpub/xapi/offers',
            couponClipPath: '/abs/stgpub/web/j4u/api/offers/clip',
            rewardUnclipPath : '/abs/stgpub/web/j4u/api/rewards/unclip?storeId={storeId}',
            birthDayModUnitXF: '/content/experience-fragments/www/for_u/foru-birthday-exp-frag/master.content.html',
            fuelStationModUnitXF: '/content/experience-fragments/www/for_u/foru-rewards-exp-frag/master.content.html',
            checkUnclipDetail: '/abs/stgpub/xapi/ocrp/rewards/clippedrewards',
            clientLibUnifiedHeaderUrl: '/etc.clientlibs/wcax-core/clientlibs/clientlib-unified-header/{banner}.min.js',
            nonEndemicAddUrl: '/content/experience-fragments/xf/weeklyad/gam-non-endemic-banner/master.content.html',
            upcDataAPI: '/abs/stgpub/xapi/catalog/products-by-upc',
            loyaltyPromotions : '/bin/safeway/loyalty/promos',
            loyaltyPromotionsV2: '/abs/stageint/ocsp/partnerofferservice/partnerOffers/allocation',
            loyaltyPromotionsCodeLink: '/abs/stageint/ocsp/partnerofferservice/partnerOffers/promoAllocation',
            foruTravelBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net?{MDPCID}',
            foruTravelManageBookingUrl: 'https://wwwforutravelcom.staging.exp-int.net/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://wwwforutravelcom.staging.exp-int.net/trips?{MDPCID}',
            ucaHttpOptionsGetProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'X-SWY_BANNER': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': '38c2e3420b8b450d9ffd5564ff22c4f0',
                'Content-Type': 'application/vnd.safeway.v2+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Name': 'web-portal'
            },
            ucaHttpOptionsUpdateProfile: {
                'Accept': 'application/vnd.safeway.v4+json',
                'Content-Type': 'application/vnd.safeway.v4.merge-patch+json',
                'X-Swy_banner': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': '38c2e3420b8b450d9ffd5564ff22c4f0',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Id': 'web-portal',
                'X-Swy-Client-Name': 'web-portal'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                "Content-Type": "application/vnd.safeway.v2+json",
                "ocp-apim-subscription-key": "7a912a136fdf4fdb84b3838dbcb677fb"
            },
            xAPIOcrpRewardsHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '7a912a136fdf4fdb84b3838dbcb677fb',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptionsV3: {
                "Content-Type": "application/vnd.safeway.v3+json",
                'Accept': 'application/vnd.safeway.v3+json',
                'X-ABS-Client-ID': 'WEB',
                "ocp-apim-subscription-key": "7a912a136fdf4fdb84b3838dbcb677fb"
            },
            j4uHttpOptions30Header: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                'X-IBM-Client-Id': 'b09e2ed0-494d-44da-bb90-70de110efb31',
                'X-IBM-Client-Secret': 'P1wX4nX1dG1iG2kM0sY0sB0rJ4oT0jT2wC1mG1vF7uY7kL3yE7',
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            j4uHttpOptionsFilterAPIHeader: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                "ocp-apim-subscription-key": "d4e34bea5de73fff74e98e411208234fc18a2b24f39f04d08239a6c7e16e61b7",
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            offerDetailsXAPIHeader: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'X-SWY-APPLICATION-TYPE': 'web',
                'X-SWY_API_KEY': 'emjou',
                'X-SWY_VERSION': '2.1'
            },
            j4uHttpOptions: {
                "Content-Type": "application/json",
                "X-Ibm-Client-Id": "b09e2ed0-494d-44da-bb90-70de110efb31",
                "X-Ibm-Client-Secret": "P1wX4nX1dG1iG2kM0sY0sB0rJ4oT0jT2wC1mG1vF7uY7kL3yE7",
                "X-Swy_api_key": "emjou",
                "X-Swy_version": "1.0",
                'X-Swy_banner': '{banner}',
            },
            rewardUnclipHttpOptions: {
                'Content-Type': 'application/json',
                'SWY_BANNER': '{banner}',
                "X-SWY_API_KEY": 'emjou',
                "X-SWY_VERSION": '1.0'
            },
            partnerPromotionV2HttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '9842ea87a5684a68816cf5c8c450b4f6',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            dynamicPartnerPromoCodeLinkHttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': '9842ea87a5684a68816cf5c8c450b4f6',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            personalizedOffer: {
                apiUrl: '/abs/stgint/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
                httpHeaders: {
                    'ocp-apim-subscription-key': 'A161f91a6dfa417c8365940f6d03f84e',
                    'Content-Type': 'application/vnd.safeway.v1+json',
                },
            }
        },
        freshpassLookupConfig: {
            freshpassURL: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            freshpassTierStatus: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/status',
            freshpassHeaders: {
                'Accept': 'application/vnd.safeway.v2+json',
                'Content-Type': 'application/json',
                'X-SWY_BANNER': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': 'd1d4174ce58d4c348f8e950a97ad4d49',
                'x-swy-client-id': 'web-portal'
            },
            tierStatusHeaders: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Content-Type': 'application/json',
                'x-swy-banner': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'ocp-apim-subscription-key': 'd1d4174ce58d4c348f8e950a97ad4d49',

            }
        },
        googleAdConfig: {
            displayAds: {
                bottomAd: true
            },
            adBanners: ['acmemarkets', 'albertsons', 'carrsqc', 'jewelosco', 'pavilions', 'randalls', 'safeway', 'shaws', 'starmarket', 'tomthumb', 'vons'],
            gptScriptSrc: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
            rewardsAdBottom: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes: [
                    [728, 90],
                    [300, 250]
                ],
                sizeMapping: [
                    [
                        [1024, 250],
                        [728, 90],
                    ],
                    [
                        [768, 250],
                        [728, 90],
                    ],
                    [
                        [360, 240],
                        [300, 250],
                    ],
                    [[0, 0], []],
                ],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            },
            endemicBottomAd: {
                adUnitPath: "/22825627079/nonprod.{banner}/foru/rewards/*.*/bottomb1",
                sizes:  ["fluid"],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            }
        },
    },
    prod: {
        currentEnv: 'prod',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        rewardsLookupConfig: {
            featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
            offerDetailsURL: '/abs/pub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
            adobeImageURL: 'https://images.albertsons-media.com/is/image/ABSStage/',
            leftNavigation: '/content/experience-fragments/www/for_u/navigation/{banner}.caas.json',
            b2BLeftNavigation: '/content/experience-fragments/b2b/for_u/navigation/{banner}.caas.json',
            getprofileAddressPath: '/abs/pub/cnc/ucaservice/api/uca/customers/{customerId}/profile',
            getRewardsScoreCard: '/abs/pub/xapi/ocrp/rewards/scorecard',
            getRewardsOffers: '/abs/pub/web/j4u/api/grocery/rewards/offers',
            getPointForServicesOffers: '/abs/pub/dce/offergallery/offers/filter',
            getRewardsHistory: '/abs/pub/xapi/ocrp/rewards/rewardsHistory',
            getRewardHistoryV2Path: '/abs/pub/xapi/ocrp/rewards/v2/rewardsHistory',
            getRewardHistoryV3Path: '/abs/pub/xapi/ocrp/rewards/v3/rewardsHistory',
            selectedRewardspath: '/abs/pub/web/j4u/api/grocery/rewards/mylist',
            offerDetailPath: '/abs/pub/web/j4u/api/offer',
            offerDetailxAPIPath: '/abs/pub/xapi/offers',
            couponClipPath: '/abs/pub/web/j4u/api/offers/clip',
            rewardUnclipPath : '/abs/pub/web/j4u/api/rewards/unclip?storeId={storeId}',
            birthDayModUnitXF: '/content/experience-fragments/www/for_u/foru-birthday-exp-frag/master.content.html',
            fuelStationModUnitXF: '/content/experience-fragments/www/for_u/foru-rewards-exp-frag/master.content.html',
            checkUnclipDetail: '/abs/pub/xapi/ocrp/rewards/clippedrewards',
            clientLibUnifiedHeaderUrl: '/etc.clientlibs/wcax-core/clientlibs/clientlib-unified-header/{banner}.min.js',
            nonEndemicAddUrl: '/content/experience-fragments/xf/weeklyad/gam-non-endemic-banner/master.content.html',
            upcDataAPI: '/abs/pub/xapi/catalog/products-by-upc',
            loyaltyPromotions : '/bin/safeway/loyalty/promos',
            loyaltyPromotionsV2: '/abs/prodint/ocsp/partnerofferservice/partnerOffers/allocation',
            loyaltyPromotionsCodeLink: '/abs/prodint/ocsp/partnerofferservice/partnerOffers/promoAllocation',
            foruTravelBookingUrl: 'https://www.forutravel.com/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://www.forutravel.com?{MDPCID}',
            foruTravelManageBookingUrl: 'https://www.forutravel.com/saveStateAndRedirect?banner={banner}&login_hint={login_hint}&rurl=https://www.forutravel.com/trips?{MDPCID}',
            ucaHttpOptionsGetProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'X-SWY_BANNER': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': '9e38e3f1d32a4279a49a264e0831ea46',
                'Content-Type': 'application/vnd.safeway.v2+json',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Name': 'web-portal'
            },
            ucaHttpOptionsUpdateProfile: {
                'Accept': 'application/vnd.safeway.v4+json',
                'Content-Type': 'application/vnd.safeway.v4.merge-patch+json',
                'X-Swy_banner': '{banner}',
                'x-swy-banner': '{banner}',
                'Ocp-Apim-Subscription-Key': '9e38e3f1d32a4279a49a264e0831ea46',
                'x-swy-client-id': 'web-portal',
                'Cache-Control': 'no-cache',
                'X-Swy-Client-Id': 'web-portal',
                'X-Swy-Client-Name': 'web-portal'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                "Content-Type": "application/vnd.safeway.v2+json",
                "ocp-apim-subscription-key": "daedbc8e06814b3f857bfe1f00270865"
            },
            xAPIOcrpRewardsHttpOptions: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'daedbc8e06814b3f857bfe1f00270865',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptionsV3: {
                "Content-Type": "application/vnd.safeway.v3+json",
                'Accept': 'application/vnd.safeway.v3+json',
                'X-ABS-Client-ID': 'WEB',
                "ocp-apim-subscription-key": "daedbc8e06814b3f857bfe1f00270865"
            },
            j4uHttpOptions30Header: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                'X-IBM-Client-Id': '306b9569-2a31-4fb9-93aa-08332ba3c55d',
                'X-IBM-Client-Secret': 'N4tK3pW7pP6nB4kL6vN4kW0rS5lE4qH2fY0aB2rK1eP5gK4yV5',
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            j4uHttpOptionsFilterAPIHeader: {
                'X-SWY_VERSION': '3.0',
                'X-SWY_BANNER': '{banner}',
                "ocp-apim-subscription-key": "d4e34bea5de73fff74e98e411208234fc18a2b24f39f04d08239a6c7e16e61b7",
                'Content-Type': 'application/json',
                'X-SWY_API_KEY': 'emjou'
            },
            offerDetailsXAPIHeader: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'X-SWY-APPLICATION-TYPE': 'web',
                'X-SWY_API_KEY': 'emjou',
                'X-SWY_VERSION': '2.1'
            },
            j4uHttpOptions: {
                "Content-Type": "application/json",
                "X-Ibm-Client-Id": "306b9569-2a31-4fb9-93aa-08332ba3c55d",
                "X-Ibm-Client-Secret": "N4tK3pW7pP6nB4kL6vN4kW0rS5lE4qH2fY0aB2rK1eP5gK4yV5",
                "X-Swy_api_key": "emjou",
                "X-Swy_version": "1.0",
                'X-Swy_banner': '{banner}',
            },
            rewardUnclipHttpOptions: {
                'Content-Type': 'application/json',
                'SWY_BANNER': '{banner}',
                "X-SWY_API_KEY": 'emjou',
                "X-SWY_VERSION": '1.0'
            },
            partnerPromotionV2HttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': 'c66a5011373848be880e9bca8c5c18be',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            dynamicPartnerPromoCodeLinkHttpOptions:{
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Ocp-Apim-Subscription-Key': 'c66a5011373848be880e9bca8c5c18be',
                'x-swy_banner': '{banner}',
                'x-swy-client-id': 'web-portal'
            },
            personalizedOffer: {
                apiUrl: '/abs/int/xapi/osdy-xapi-web-shopdeals/webShopDeals/getZone',
                httpHeaders: {
                    'ocp-apim-subscription-key': '5bf18a05fe7e43a09f1071ecd3b6e618',
                    'Content-Type': 'application/vnd.safeway.v1+json',
                },
            }
        },
        freshpassLookupConfig: {
            freshpassURL: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            freshpassTierStatus: '/abs/pub/erums/subscriptionservice/api/v1/subscription/status',
            freshpassHeaders: {
                'Accept': 'application/vnd.safeway.v2+json',
                'Content-Type': 'application/json',
                'X-SWY_BANNER': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'ocp-apim-subscription-key': 'ce9603bf4ce54fd28fced4dfc3a1c0de',
                'x-swy-client-id': 'web-portal'
            },
            tierStatusHeaders: {
                'Accept': 'application/vnd.safeway.v1+json',
                'Content-Type': 'application/json',
                'x-swy-banner': '{banner}',
                'banner': '{banner}',
                'cache-control': 'no-cache',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'ocp-apim-subscription-key': 'ce9603bf4ce54fd28fced4dfc3a1c0de',
            }
        },
        googleAdConfig: {
            displayAds: {
                bottomAd: true
            },
            adBanners: ['acmemarkets', 'albertsons', 'carrsqc', 'jewelosco', 'pavilions', 'randalls', 'safeway', 'shaws', 'starmarket', 'tomthumb', 'vons'],
            gptScriptSrc: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
            rewardsAdBottom: {
                adUnitPath: "/22389494054/{banner}/foru/rewards/*.*/bottomb1",
                sizes: [
                    [728, 90],
                    [300, 250]
                ],
                sizeMapping: [
                    [
                        [1024, 250],
                        [728, 90],
                    ],
                    [
                        [768, 250],
                        [728, 90],
                    ],
                    [
                        [360, 240],
                        [300, 250],
                    ],
                    [[0, 0], []],
                ],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            },
            endemicBottomAd: {
                adUnitPath: "/22389494054/{banner}/foru/rewards/*.*/bottomb1",
                sizes:  ["fluid"],
                targeting: [
                    { txid: "ProductAlike" },
                    { txpath: "1" },
                    { store: "" },
                    // { ado_vid: "" },
                    // { ccn_sid: "" }
                ]
            }
        },
    }
};
